import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { ACTIVITYV3_TYPE_KOR } from 'src/constants/activityv3.enum';
import { ResponseActivityV3ByStudentDto } from 'src/generated/model';
import { getFilteredSessions, isEnded } from 'src/util/activityv3';
import { ButtonV2 } from '../common/ButtonV2';
import { Typography } from '../common/Typography';
import SVGIcon from '../icon/SVGIcon';
import { ActivitySessionCard } from './ActivitySessionCard';

interface ActivityV3CardProps {
  activityv3: ResponseActivityV3ByStudentDto;
}

export function ActivityV3Card({ activityv3 }: ActivityV3CardProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { push } = useHistory();

  // 필터링된 세션 데이터를 미리 계산
  const filteredSessions = getFilteredSessions(activityv3.activitySessions);
  const hasFilteredSessions = filteredSessions.length > 0;

  return (
    <div className="shadow-[0_4px_8px_0_#F4F6F8)] flex flex-col rounded-xl border border-primary-gray-200 bg-white p-4">
      <header
        className="flex cursor-pointer flex-row items-center justify-between"
        onClick={() => push(`/student/activity/${activityv3.id}`)}
      >
        <div className="flex flex-col gap-0.5">
          <Typography variant="title3" className="line-clamp-2 font-semibold">
            {activityv3.title}
          </Typography>
          <Typography variant="body3" className="flex flex-row items-center gap-1 text-primary-gray-700">
            {ACTIVITYV3_TYPE_KOR[activityv3.type]}
            <SVGIcon.Bullet color="gray400" size={20} />
            {activityv3.subject}
          </Typography>
        </div>
        <ButtonV2 variant="solid" color="gray100" size={32}>
          상세
        </ButtonV2>
      </header>
      {hasFilteredSessions && (
        <div className="flex flex-col gap-2 pt-2">
          {isOpen && (
            <main className="flex flex-col gap-2">
              {filteredSessions.map((session) => (
                <ActivitySessionCard
                  key={session.id}
                  activitySession={session}
                  isSubmitted={!!session.studentActivitySessions && session.studentActivitySessions.length > 0}
                  id={activityv3.id}
                  isEnded={isEnded(session.endDate)}
                />
              ))}
            </main>
          )}
          <footer
            className="flex cursor-pointer flex-row justify-center gap-1 py-1.5"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? (
              <Typography
                variant="body3"
                className="flex flex-row items-center gap-1 font-medium text-primary-gray-700"
              >
                접기 <SVGIcon.Arrow color="gray700" size={12} rotate={90} />
              </Typography>
            ) : (
              <Typography
                variant="body3"
                className="flex flex-row items-center gap-1 font-medium text-primary-gray-700"
              >
                차시보기 <SVGIcon.Arrow color="gray700" size={12} rotate={270} />
              </Typography>
            )}
          </footer>
        </div>
      )}
    </div>
  );
}
